"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _mathjs = require("mathjs");

var _default = function _default() {
  return {
    name: 'calc',
    synopsis: 'calc [EXPRESSION]',
    description: 'Evaluate a mathematical expression',
    options: {},
    format: function format(output) {
      return String(output);
    },
    execute: function execute(args) {
      return (0, _mathjs.evaluate)(args.join(''));
    }
  };
};

exports.default = _default;